<template>
	<span>
		<span @click="showImgDialog" >
			<slot>
				<Button type="warning">{{title}}</Button>
			</slot>
		</span>
		
		<!-- 图片浏览器 -->
		<Modal v-model="dialog" :styles="styles" :title="title" :width="width">
			<Carousel loop v-if="dialog" :height="height">
	    		<CarouselItem v-for="img in imgs" :style="{'text-align':'center'}">
	     			<img alt="点击下载" :src="img.url" @click="clickImg(img)" :style="style"/>
	       		</CarouselItem>
	     	</Carousel>
	    </Modal>
	</span>
</template>
<script>
import Vue from 'vue';
import Setting from '@/setting';

/**
 * 图片浏览器
 *<ab-img-previewer v-model="file"></ab-img-previewer> 
 * file:fileId1,fileId2,...
 */
export default {
	props: {
		styles : {
			default : () => {
				return {top: '20px'};
			}
		},
		title : {
			default : "查图"
		},
		width : {
			default : "1000px"
		},
		height : {
			default : "450px"
		},
		value : {
			required : true
		}
	},
  	data :function () {
	    return {
	    	dialog : false,
	  		style : {
	  			cursor : "pointer",
	  			"vertical-align" : "middle"
	  		},
	  		imgDialog : false,
  			imgs : []
	    }
	},
	created : function(){
		this.style["max-height"] = this.width;
		this.style["max-width"] = this.height;
	},
 	mounted : function(){
 		
 	},
	methods: {
		showImgDialog : function(){
			this.imgs.splice(0);
			this.value.split(",").forEach(f => {
				let url = Setting.apiBaseURL + "/sys/sysFile/download?fileId=" + f;
				let img = {
					url : url,
					id : f
				};
				this.imgs.push(img);
			});
			
			this.dialog = true;
		},
		clickImg : function(img){
 			window.open(img.url, "_blank");
		}
  	},
}
</script>
